import { ReduxActions } from '@src/redux/actions/interfaces/action.interface';
import { BodyBackdropActions } from '@src/redux/actions/bodyBackdrop/backdrop.enum';
import { NoticeState } from './notice.interface';

const { SET_BODY_BACKDROP, REMOVE_BODY_BACKDROP } = BodyBackdropActions;

const DEFAULT_STATE = {
  isBodyBackdropVisible: false,
};

export function bodyBackdrop(state = DEFAULT_STATE, action: ReduxActions): NoticeState {
  switch (action.type) {
    case SET_BODY_BACKDROP:
      return {
        ...state,
        isBodyBackdropVisible: action.isBodyBackdropVisible,
      };
    case REMOVE_BODY_BACKDROP:
      return {
        ...state,
        isBodyBackdropVisible: action.isBodyBackdropVisible,
      };
    default:
      return state;
  }
}
